import React, { useState } from 'react';
import { Button, Container, Header, Input, Table } from 'semantic-ui-react';
import { api_url } from '../../../api/apiTools';
import toastr from 'toastr';

const EXTRACT_ITEMS: { label: string; exportItem: string }[] = [
    { label: 'Extract Distributors', exportItem: 'EXPORTDATA_DISTRIBUTORS' },
    { label: 'Extract Products', exportItem: 'EXPORTDATA_PRODUCTS' },
    { label: 'Extract Party Products', exportItem: 'EXPORTDATA_PARTYPRODUCTS' },
    {
        label: 'Extract Product Risk Assessments',
        exportItem: 'EXPORTDATA_EXECUTION_CDPRODUCTRISKASSESSMENT',
    },
    {
        label: 'Extract Outcomes',
        exportItem: 'EXPORTDATA_EXECUTION_CDOUTCOMES',
    },
    {
        label: 'Extract Value Outcomes',
        exportItem: 'EXPORTDATA_EXECUTION_CDVALUEOUTCOME',
    },
    {
        label: 'Extract Governance',
        exportItem: 'EXPORTDATA_EXECUTION_CDGOVERNANCE',
    },
    { label: 'Extract Lookups', exportItem: 'EXPORTDATA_LOOKUPS' },
    { label: 'Extract Ratings', exportItem: 'EXPORTDATA_RATINGS' },
    { label: 'Extract Actions', exportItem: 'EXPORTDATA_EXECUTION_ACTIONS' },
    {
        label: 'Extract Fair Value',
        exportItem: 'EXPORTDATA_EXECUTION_FAIRVALUE',
    },
];

const DataExtractsPage = () => {
    const [apiKey, setApiKey] = useState('');
    const [loadingItem, setLoadingItem] = useState<string | null>(null);

    const handleDownload = async (exportItem: string) => {
        if (!apiKey.trim()) {
            toastr.warning('Please enter an API key');
            return;
        }
        setLoadingItem(exportItem);
        try {
            const url = `${api_url()}Utils/exportData`;
            const body = new URLSearchParams({
                exportKey: apiKey.trim(),
                exportItem,
                exportAsFile: '1',
            });
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                body: body.toString(),
            });
            const data = await res.json().catch(() => null);
            if (!res.ok) {
                const message =
                    data?.error?.message ||
                    data?.message ||
                    `Request failed with status ${res.status}`;
                throw new Error(message);
            }
            if (data?.downloadUrl) {
                const link = document.createElement('a');
                link.href = data.downloadUrl;
                link.click();
            } else {
                toastr.info(data?.message || 'Export complete');
            }
        } catch (error) {
            toastr.error(
                error instanceof Error ? error.message : 'Export failed',
            );
        } finally {
            setLoadingItem(null);
        }
    };

    return (
        <Container>
            <Header as="h2">Data Extracts</Header>
            <Input
                placeholder="Paste API key here..."
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                style={{ width: '400px', marginBottom: '1.5rem' }}
            />
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Extract</Table.HeaderCell>
                        <Table.HeaderCell width={3}>Action</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {EXTRACT_ITEMS.map(({ label, exportItem }) => (
                        <Table.Row key={exportItem}>
                            <Table.Cell>{label}</Table.Cell>
                            <Table.Cell>
                                <Button
                                    primary
                                    icon="download"
                                    content="Download"
                                    loading={loadingItem === exportItem}
                                    disabled={!!loadingItem}
                                    onClick={() => handleDownload(exportItem)}
                                />
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </Container>
    );
};

export default DataExtractsPage;
